import React, { useEffect, useState } from 'react';
import '../CSS/style/style.css';
import logo from "../resource/water_about.jpeg";

const About = () => {
    const [activeTab, setActiveTab] = useState('about');

    useEffect(() => {
        if (activeTab !== 'visit') return;

        const initMap = () => {
            window.kakao.maps.load(() => {
                const container = document.getElementById('kakao-map');
                if (!container) return;
                const options = {
                    center: new window.kakao.maps.LatLng(36.309391410701, 129.251437785207),
                    level: 3,
                };
                const map = new window.kakao.maps.Map(container, options);
                const marker = new window.kakao.maps.Marker({ position: options.center });
                marker.setMap(map);
            });
        };

        // 이미 로드된 경우 바로 초기화
        if (window.kakao && window.kakao.maps) {
            initMap();
            return;
        }

        // 스크립트 중복 추가 방지
        if (document.querySelector('script[src*="dapi.kakao.com"]')) return;

        const script = document.createElement('script');
        script.src = "//dapi.kakao.com/v2/maps/sdk.js?appkey=80b7c5b112ad9fdb2ed70d52ee0009c4&autoload=false";
        script.async = true;
        script.onload = initMap;
        document.head.appendChild(script);
    }, [activeTab]);

    return (
        <div className="main-wrapper">
            <section className="foot-banner"></section>

            <div className="main-container">
                <div className="tab-buttons">
                    <button
                        onClick={() => setActiveTab('about')}
                        className={activeTab === 'about' ? 'tab-button active' : 'tab-button'}
                    >
                        ABOUT
                    </button>
                    <button
                        onClick={() => setActiveTab('visit')}
                        className={activeTab === 'visit' ? 'tab-button active' : 'tab-button'}
                    >
                        오시는 길
                    </button>
                </div>

                {activeTab === 'about' && (
                    <>
                        <div className="section-header">
                            <span className="section-label">ABOUT</span>
                            <h2 className="section-title">펜션 소개</h2>
                        </div>
                        <div className="about-image-wrapper">
                            <img src={logo} alt="펜션 소개" className="about-image"/>
                            <div className="about-overlay">
                                <span>
                                    독특하면서도 평화로운 이곳에서 편안한 휴식을 즐기세요.<br/><br/>
                                    사계절마다 다양한 꽃이 피고 지는 아름다운 정원과<br/>
                                    아이들과 뛰어놀기 좋은 마당, 트램폴린이 준비되어 있습니다.<br/><br/>
                                    각 별채마다 개인 바베큐장이 있으며, 숯불 이용 시<br/>
                                    사장님께 미리 말씀해 주세요.<br/><br/>
                                    매점, 백숙, 치킨, 커피, 생맥주도 펜션 내에서 운영 중입니다.<br/>
                                    몸만 오시면 됩니다!<br/><br/>
                                    단체/행사 문의도 언제든지 환영합니다 :)
                                </span>
                            </div>
                        </div>
                    </>
                )}

                {activeTab === 'visit' && (
                    <>
                        <div className="section-header">
                            <span className="section-label">LOCATION</span>
                            <h2 className="section-title">오시는 길</h2>
                        </div>
                        <div className="visit-container">
                            <div id="kakao-map"></div>
                            <div className="visit-info">
                                안녕하세요, 물조은펜션입니다.<br/><br/>
                                물조은펜션 방문 시 네비게이션에<br/>
                                <b>"상옥농협 혹은 상옥보건소"</b>를 먼저 검색하시고,<br/>
                                <b>"죽장로 2900"</b>을 재검색해 오시기 바랍니다.<br/><br/>
                                <span className="visit-notice">
                                    * 바로 "물조은펜션" 검색 시 영덕 옥계 방향의<br/>
                                    비포장도로로 안내되어 길이 험할 수 있으니, 참고 부탁드립니다.
                                </span>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default About;
